import { useEffect, useContext, useState } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import AllowIpController from '../../controllers/system/AllowIpController';

const AllowIp = () => {
  useEffect(() => {
    document.title = '허용 IP 관리';
  }, []);
  const { store } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);

  const [dataList, setDataList] = useState([]);
  const [deletedRows, setDeletedRows] = useState([]);
  const [originalDataList, setOriginalDataList] = useState([]);

  const controller = new AllowIpController(
    store,
    modalService,
    validateService,
    [],
    {
      dataList,
      setDataList,
      deletedRows,
      setDeletedRows,
      originalDataList,
      setOriginalDataList,
    }
  );

  useEffect(() => {
    controller.loadIpList();
  }, []);

  const handleAddRow = () => {
    const newRow = {
      rowNo: dataList.length + 1,
      ipAddr: '',
      entNm: '',
      selected: false,
      useYn: 'Y',
    };
    setDataList([...dataList, newRow]);
  };

  const handleDeleteRows = () => {
    controller.deleteRow();
  };

  const handleSaveChanges = async () => {
    await controller.saveChanges();
  };

  const handleInputChange = (rowNo, key, value) => {
    setDataList(prevList =>
      prevList.map(row =>
        row.rowNo === rowNo ? { ...row, [key]: value } : row
      )
    );
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">허용 IP 관리</h2>
      </div>
      <ul className="guide-txt">
        <li>관리자 로그인에 접근 가능한 IP 주소를 추가/삭제할 수 있습니다.</li>
      </ul>
      <div className="tbl-wrap">
        <h3 className="block-tit">
          허용 IP 목록 <em className="star-require">*</em>
        </h3>
        <table className="tbl col data scroll">
          <thead>
            <tr>
              <th>선택</th>
              <th>IP 주소</th>
              <th>사용자</th>
              <th>사용 여부</th>
            </tr>
          </thead>
          <tbody>
            {dataList.map(row => (
              <tr key={row.rowNo}>
                <td>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id={`checkbox_${row.rowNo}`}
                      name="selected"
                      checked={row.selected || false}
                      onChange={e =>
                        handleInputChange(
                          row.rowNo,
                          'selected',
                          e.target.checked
                        )
                      }
                    />
                    <label htmlFor={`checkbox_${row.rowNo}`}></label>
                  </div>
                </td>
                <td>
                  <label
                    className="hidden-label"
                    htmlFor={`ipAddr_${row.rowNo}`}
                  >
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control sm"
                    value={row.ipAddr}
                    onChange={e =>
                      handleInputChange(row.rowNo, 'ipAddr', e.target.value)
                    }
                    id={`ipAddr_${row.rowNo}`}
                    aria-labelledby={`ipAddr_${row.rowNo}`}
                  />
                </td>
                <td>
                  <label
                    className="hidden-label"
                    htmlFor={`entNm_${row.rowNo}`}
                  >
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control sm"
                    value={row.entNm}
                    onChange={e =>
                      handleInputChange(row.rowNo, 'entNm', e.target.value)
                    }
                    id={`entNm_${row.rowNo}`}
                    aria-labelledby={`entNm_${row.rowNo}`}
                  />
                </td>
                <td>
                  <label
                    className="hidden-label"
                    htmlFor={`useYn_${row.rowNo}`}
                  >
                    라벨
                  </label>
                  <select
                    className="form-select sm"
                    value={row.useYn}
                    onChange={e =>
                      handleInputChange(row.rowNo, 'useYn', e.target.value)
                    }
                    aria-labelledby={`useYn_${row.rowNo}`}
                    id={`useYn_${row.rowNo}`}
                  >
                    <option value="Y">허용</option>
                    <option value="N">차단</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="page-btn-wrap both">
        <div className="btn-wrap">
          <button
            type="button"
            className="btn xlg tertiary"
            onClick={handleAddRow}
          >
            행 추가
          </button>
          <button
            type="button"
            className="btn xlg tertiary"
            onClick={handleDeleteRows}
          >
            행 삭제
          </button>
        </div>
        <button
          type="button"
          className="btn xlg primary"
          onClick={handleSaveChanges}
        >
          저장하기
        </button>
      </div>
    </>
  );
};

export default AllowIp;
